var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57163 9.6C8.24297 9.6 7.11082 9.13217 6.17514 8.19649C5.23946 7.26081 4.77163 6.12866 4.77163 4.8C4.77163 3.47134 5.23946 2.33919 6.17514 1.40351C7.11082 0.467832 8.24297 0 9.57163 0C10.9003 0 12.0324 0.467832 12.9681 1.40351C13.9038 2.33919 14.3716 3.47134 14.3716 4.8C14.3716 6.12866 13.9038 7.26081 12.9681 8.19649C12.0324 9.13217 10.9003 9.6 9.57163 9.6ZM9.57162 12.014C10.7506 12.014 12.0511 12.1825 13.4734 12.5193C14.8956 12.8561 16.1962 13.4082 17.3751 14.1754C18.5541 14.9427 19.1436 15.8129 19.1436 16.786V19.2H-0.000305176V16.786C-0.000305176 15.8129 0.589163 14.9427 1.76812 14.1754C2.94707 13.4082 4.24764 12.8561 5.66987 12.5193C7.0921 12.1825 8.39267 12.014 9.57162 12.014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2b226706b33f2b3438fc40c2289985c9.svg";
export { ForwardRef as ReactComponent };